import { Link } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';
import ddabroadlogo from "../../assests/images/ddabroadlogo.png";
import './index.css';

const Header = () => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  const toggleMenu = () => setOpen(prev => !prev);

  // Close menu on outside click
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (open && menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [open]);

  return (
    <>
    <p className='call-us'>📞 Call us anytime! on +917386770284</p>
    <nav className="nav-header" ref={menuRef}>
      <div className="nav-content">
        <div className='logo-name-brand'>
          <div>
          <Link to="/">
          <img src={ddabroadlogo} alt='brandlogo' className='website-logo' />
        </Link>
          </div>
        
        <p style={{color : "#C62828"}}>DREAM DESTINATION</p>
        </div>
        

        <ul className="nav-menu">
          <li><Link to="/" className="nav-link">Home</Link></li>
          <li><Link to="/services" className="nav-link">Services</Link></li>
          <li><Link to="/about" className="nav-link">About</Link></li>
          <li><Link to="/contact" className="nav-link">Contact Us</Link></li>
        </ul>

        <button
          type="button"
          className="logout-mobile-btn"
          onClick={toggleMenu}
        >
          {open ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#475569" viewBox="0 0 16 16">
              <path d="M4.646 4.646a.5.5 0 011 0L8 6.293l2.354-2.647a.5.5 0 01.707.707L8.707 7l2.647 2.354a.5.5 0 01-.707.707L8 7.707l-2.354 2.647a.5.5 0 01-.707-.707L7.293 7 4.646 4.646a.5.5 0 010-.707z"/>
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#475569" className="bi bi-list" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5z"/>
            </svg>
          )}
        </button>
      </div>

      {open && (
        <ul className="dropdown-menu">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/services">Services</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          <li><Link to="/about">About</Link></li>
          <li style={{ backgroundColor: "red", borderRadius: "10px" }}>
            <Link to="/applynow" style={{ color: "white" }}>Book a Free Demo</Link>
          </li>
        </ul>
      )}
    </nav>
    </>
  );
};

export default Header;
